import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services';
import { take, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {

	constructor(
    public authService: AuthService, 
    public router: Router
    ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    let isLoggedIn = this.authService.whenLoggedIn.getValue();
    let faqIsShown = sessionStorage.getItem('initView');

    /**
     * Handling if Sign Up is not yet allowed
     */


    if (!this.authService.isSignUpAllowed() && next.url[0].path == 'register') {
      this.redirect('/not-found') // not an actual url we are just triggering not found page
      return false;
    }

    /**
     * Basically this is the logic of this routing mechanism:
     * showFaqFirst & allowLogin = show faq, flag as shown, if shown, do nothing
     * !showFaqFisrt & !allowLogin = show faq always
     * showFaqFisrt & !allowlogin = show faq always
     * !showFaqFisrt & allowlogin = do nothing
     */

    if (isLoggedIn) {
      this.router.navigate(['/']);
    } else {
      if (!environment.allowLogin) {
        this.redirect('/frequently-asked-questions')
      } else {
        if (environment.showFaqFirst && !faqIsShown) {
          this.redirect('/frequently-asked-questions')
          sessionStorage.setItem('initView', "1")
        }
      }
      
    }

    return !isLoggedIn;
  }

  redirect(url:string) {
    this.router.navigate([url])
  }
}
